// extracted by mini-css-extract-plugin
module.exports = {"sidebar-wrapper":"sidebar_sidebar-wrapper__22GTg","route-link":"sidebar_route-link__14k8J","active-link":"sidebar_active-link__LFf0H"};